import {useMenu} from "react-instantsearch-hooks-web";
import ComboboxSelect from "./ComboboxSelect";
import {useContext, useState} from "react";
import FilterContext from "../../Context/FilterContext";

const label = 'Toutes les spécialités'
const value = '*'

const SpecialitySelect = props => {
    const {speciality, setSpeciality, setLoading} = useContext(FilterContext)

    const {items, refine} = useMenu(props)

    const [firstLoad, setFirstLoad] = useState(true)

    const handleChange = item => {
        if (item === null) return;

        setLoading(true)

        const isDefaultValue = item.value === value

        if (firstLoad && isDefaultValue) return;
        if (speciality === value && isDefaultValue) return;
        if (item.value === speciality && item.count !== undefined) return;

        refine(isDefaultValue ? undefined : item.value)
        setSpeciality(item.value)
        setFirstLoad(false)
    }

    return (
        <ComboboxSelect
            items={[{ label: label, value: value }, ...items]}
            handleChange={handleChange}
            value={speciality}
            {...props}
        />
    )
}

export default SpecialitySelect